import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { VkMusicBundleActions } from 'reactApp/modules/vkMusic/vkMusic.module';

export const useVKIDFromQuery = () => {
    const dispatch = useDispatch();
    const queryParams = getQueryParams();

    const isFromAction = queryParams?.action === 'request-payment';
    const vkid = isFromAction ? queryParams?.vkid : '';

    useEffect(() => {
        if (!isFromAction) {
            return;
        }
        dispatch(VkMusicBundleActions.setVkMusicBundleVKID({ vkid }));
    }, [vkid, isFromAction]);
};
